import { IApplicationState } from '../../types/redux';
import { getTemplateSpecialPromo } from './templateSpecialPromo/getTemplateSpecialPromo';

export function getDeveloperHeaderLogo(state: IApplicationState): string | undefined {
  return getTemplateSpecialPromo(state)?.logoHeader.url;
}
